import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';

function WishListUIList() {

    let TOGGLE_CSS_CLASS = 'wish-list-toggle';
    let EXISTS_IN_LIST_CSS_CLASS = 'exists-in-wish-list';

    this.defaultAttrs({
        addToWishList: '[data-add-to-wish-list]',
        removeFromWishList: '[data-remove-from-wish-list]',
        initData: null,
        searchIdSelector: '[data-search-id]'
    });

    this._addItemToWishList = function (e, payload) {
        e.preventDefault();
        e.stopPropagation();

        this._triggerWishListAction('ui:item:on-add-to-wish-list', $(payload.el));
    };

    this._removeItemFromWishList = function (e, payload) {
        e.preventDefault();
        e.stopPropagation();

        let button = $(payload.el);

        let removeFromDom = button.data('remove-item-from-dom');
        if (removeFromDom) {
            let item = button.closest(removeFromDom);
            item.fadeOut('slow', function () {
                item.remove();
            });
        }

        this._triggerWishListAction('ui:item:on-remove-from-wish-list', button);
    };

    this._triggerWishListAction = function (eventName, button) {
        let itemNode = button.closest('[data-item-id]');

        // prevent double clicks
        if (itemNode.hasClass(TOGGLE_CSS_CLASS)) {
            return;
        }

        let itemId = itemNode.data('item-id');
        let searchId = itemNode.find(this.attr.searchIdSelector).data('search-id');

        itemNode.addClass(TOGGLE_CSS_CLASS);
        this.trigger(document, eventName, { itemId: itemId, s: searchId });
    };


    this._wishListItemAdded = function (e, payload) {
        let itemNode = this.$node.find('[data-item-id=' + payload.itemId + ']');

        itemNode.removeClass(TOGGLE_CSS_CLASS).addClass(EXISTS_IN_LIST_CSS_CLASS);

        this._triggerGAEventAction('add');

        let categoryId = $(itemNode).children().first().data('item-category-id');
        this.trigger(document, 'nuggad:on-add-to-wish-list', {
            categoryId: categoryId
        });
    };

    this._wishListItemRemoved = function (e, payload) {
        let itemNode = this.$node.find('[data-item-id=' + payload.itemId + ']');

        itemNode.removeClass(TOGGLE_CSS_CLASS).removeClass(EXISTS_IN_LIST_CSS_CLASS);

        this._triggerGAEventAction('remove');
    };

    this._triggerGAEventAction = function (actionName) {
        this.trigger(document, 'analytics:track-event', {
            category: 'Wish list',
            action: actionName,
            label: this.attr.initData.pageName,
            userTriggered: true
        });
    };

    this.after('initialize', function () {
        this.on('click', {
            addToWishList: this._addItemToWishList,
            removeFromWishList: this._removeItemFromWishList
        });

        this.on(document, 'data:item:wish-list-item-added', this._wishListItemAdded);
        this.on(document, 'data:item:wish-list-item-removed', this._wishListItemRemoved);
    });
}

export default  defineComponent.component(WishListUIList);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/wish-list-ui-for-list.js